import React, { useState } from 'react';
import './../../entrydoor.css';
import { Url } from '../../url.js'; // Import the base URL

const SillType = ({ value, onChange, label = 'Type', childs = [] }) => {
    const [selectedSillType, setSelectedSillType] = useState(value || "");

    const visibleShapes  = ["Standard", "Handicap"];
    const visibleShapes2 = ["H"];

    const handleSillTypeChange = async (e) => {
        const newValue = e.target.value;
        setSelectedSillType(newValue); // Update local state
        //onChange([]); // Clear SillTypeData before fetching new data

        // Dynamically fetch and modify styles for dependent controls if any exist
        if (Array.isArray(childs) && childs.length > 0) {
            childs.forEach((childId) => {
                const element = document.getElementById(childId);
                if (element) {
                    element.selectedIndex = 0;
                    //element.options[0].selected = true;
                    element.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    const label = element.previousElementSibling; // Fetch the label, if present
                    if (label) {
                        label.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    }
                    if ((childId === "SillHorn") && (newValue === "Handicap")){
                        element.style.display = "none";
                        if (label) {
                            label.style.display = "none";
                        }

                    }
                }
            });
        }

        const selectElement = document.getElementById('SillFinish');
        selectElement.value = ""; 
        const options = selectElement.options;
        let state1 = "none"; 
        let state2 = "";
        if ( newValue === 'Standard' ){
            state1 = "";
            state2 = "none";
        }
        for (let i = 0; i < options.length; i++) {
            if ((options[i].value === "ClearAnodized") || (options[i].value === "BlackAnodized")) {
                options[i].style.display = state1; // Makes the option invisible
                //options[i].selected = false; 
            }
            if (options[i].value === "Mill") {
                options[i].style.display = state2; // Makes the option invisible
                //options[i].selected = false; 
            }
        }
    };


    return (
        <div className="a-container">
            <label htmlFor="SillType">{label}</label>
            <select
                id="SillType"
                value={selectedSillType}
                onChange={handleSillTypeChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Standard">
                    {selectedSillType === "Standard" ? "Standard ✔" : "Standard"}
                </option>
                <option value="Handicap">
                    {selectedSillType === "Handicap" ? "Handicap ✔" : "Handicap"}
                </option>
            </select>
        </div>
    );
};

export default SillType;
